'use client';

import React from 'react';
import { TablePrimaryPropTypes } from './TablePrimary.types';
import styles from './TablePrimary.module.css';
const TablePrimary: React.FC<TablePrimaryPropTypes> = ({
  className = '',
  headerRow,
  bodyRows
}) => {
  const tableScrollRef: any = React.useRef(null);
  const hintLeftRef: any = React.useRef(null);
  const hintRightRef: any = React.useRef(null);
  React.useEffect(() => {
    const tableScroll = tableScrollRef.current;
    const hintLeft = hintLeftRef.current;
    const hintRight = hintRightRef.current;
    function updateScrollHints() {
      const scrollPercent = tableScroll.scrollLeft / (tableScroll.scrollWidth - tableScroll.clientWidth) * 100;
      // Use opacity to control visibility, enabling fade in/out
      hintRight.style.opacity = scrollPercent < 98 ? '1' : '0';
      hintLeft.style.opacity = scrollPercent > 2 ? '1' : '0';
    }
    tableScroll.addEventListener('scroll', updateScrollHints);
    // Initial check is not necessary for the left hint as it should not show initially
    // but necessary for right hint if the table is already at the end when loaded.
    updateScrollHints();

    // Cleanup function to remove the event listener on component unmount
    return () => tableScroll.removeEventListener('scroll', updateScrollHints);
  }, []);
  return <div className={`${styles.tableScroll} relative`} data-sentry-component="TablePrimary" data-sentry-source-file="TablePrimary.tsx">
      <div ref={hintLeftRef} className={styles.scrollHint + ' ' + styles.scrollHintLeft}></div>

      <div ref={tableScrollRef} className={styles.tableScroll}>
        <table className={`${styles.roundedTable} ${styles.table} ${className}`}>
          {headerRow && <thead className='border-primary'>{headerRow}</thead>}
          {bodyRows && <tbody className=''>{bodyRows}</tbody>}
        </table>
      </div>

      <div ref={hintRightRef} className={styles.scrollHint + ' ' + styles.scrollHintRight}></div>
    </div>;
};
export default TablePrimary;